import { render, staticRenderFns } from "./ListSamplesArea.vue?vue&type=template&id=60b29987"
import script from "./ListSamplesArea.vue?vue&type=script&lang=js"
export * from "./ListSamplesArea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports